<ng-container *ngIf="outlined; else raisedButton">
  <button
  [class.text-hidden] = "showAsCollapsed"
  [class.text-unhide-hover] = "showAsCollapsed"
  mat-stroked-button
  appAuthorization
  [policy]="[SecurityPolicies.CanMoveTank]"
  [policyOptions]="{
    policyAction: 'Disable',
    componentRef: this
  }"
  color="primary"
  (click)="onClick()"
  [disabled]="disabled"
  >
  <i class="fas fa-dolly"></i>
  <span class="button-text">{{ buttonText }}</span>
</button>
  
</ng-container>

<ng-template #raisedButton>
  <button
  [class.text-hidden] = "showAsCollapsed"
  [class.text-unhide-hover] = "showAsCollapsed"
  mat-raised-button
  appAuthorization
  [policy]="[SecurityPolicies.CanMoveTank]"
  [policyOptions]="{
    policyAction: 'Disable',
    componentRef: this
  }"
  color="primary"
  (click)="onClick()"
  [disabled]="disabled"
  >
  <i class="fas fa-dolly"></i>
  <span class="button-text">{{ buttonText }}</span>
</button>
</ng-template>

